import type {ReactElement} from 'react';
import {useState} from 'react';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize, InputFieldState, InputFieldType} from '@Components/input-field-v2/input-field.types';
import {Text, TextSize} from '@Components/text';
import {RegistrationButtonTextPicker} from '@Components/event-wizard/event-wizard-ticketing/components/registration-button-text-picker/registration-button-text-picker';
import {useEventWizardRegistrationDetails, useEventWizardShouldCheckErrState} from '@Components/event-wizard/event-wizard.hooks';
import {onEventWizardRegistrationChange} from '@Components/event-wizard/event-wizard-slice';
import {isValidURL2} from '@Utils/url.util';
import {useAppDispatch} from '@/hooks';

export function TicketingCustomLinkCard(): ReactElement {
  const dispatch = useAppDispatch();
  const registrationDetails = useEventWizardRegistrationDetails();
  const shouldCheckForErr = useEventWizardShouldCheckErrState();

  const [linkInput, setLinkInput] = useState<string>(registrationDetails.registerBtnLink ?? '');
  const [isLinkInvalid, setIsLinkInvalid] = useState<boolean>(false);

  // Inline (typed-an-invalid-link) error OR the footer's step-2 gate flagging a missing/invalid saved link.
  const showLinkError = isLinkInvalid || (shouldCheckForErr && !isValidURL2(registrationDetails.registerBtnLink ?? ''));

  const saveLink = (): void => {
    const trimmed = linkInput.trim();
    if (trimmed !== '' && !isValidURL2(trimmed)) {
      setIsLinkInvalid(true);
      return;
    }
    setIsLinkInvalid(false);
    dispatch(onEventWizardRegistrationChange({...registrationDetails, registerBtnLink: trimmed === '' ? undefined : trimmed}));
  };

  return (
    <div className="flex-column-align-start _full-width gap-4 spacing-m-t-4 spacing-p-t-4">
      <RegistrationButtonTextPicker />
      <div className="flex-column-align-start _full-width">
        <Text className="spacing-m-b-2" val={window.i18next.t('pmwjs_button_link')} size={TextSize.SM} bold />
        <InputField
          className={showLinkError ? 'js-event-wizard-error' : ''}
          input={linkInput}
          inputType={InputFieldType.TEXT}
          inputClassName="corner-radius-8"
          size={InputFieldSize.SMALL}
          placeholder="https://www.postermywall.com"
          state={showLinkError ? InputFieldState.ERROR : InputFieldState.DEFAULT}
          information={showLinkError ? window.i18next.t('pmwjs_enter_a_valid_link') : undefined}
          onInputChange={(val): void => {
            setLinkInput(val.toString());
            setIsLinkInvalid(false);
          }}
          onInputBlur={saveLink}
          onInputSubmit={saveLink}
        />
      </div>
    </div>
  );
}
